module.exports = __webpack_public_path__ + "static/media/gos_zakypki.ab4e014e.doc";